<template>
	<Layout>
		<div class="l-container">
			<MatchCenterEuf
				v-if="$arenaConfig.isEuf"
				:teams="teams"
				:league-id="leagueId"
			/>
			<MatchCenter
				v-else
				:teams="teams"
				:league-id="leagueId"
				:seasons="seasons"
			/>
		</div>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import MatchCenter from '@js/components/MatchCenter/MatchCenter';
import MatchCenterEuf from '@js/components/MatchCenter/MatchCenterEuf';

export default {
	name:       'ViewMatchCenter',
	components: { Layout, MatchCenter, MatchCenterEuf },
	props:      {
		teams: {
			type:     Array,
			required: true,
		},
		leagueId: {
			type:     Number,
			required: true,
		},
		seasons: {
			type:    Array,
			default: () => [],
		},
	},
};
</script>

<style>

</style>
